import { Pressable, StyleSheet, Text, View } from 'react-native';
import colors from '../theme';

interface AuthorCardProps {
  name: string;
  selected?: boolean;
  onPress: () => void;
}

export default function AuthorCard({ name, selected = false, onPress }: AuthorCardProps) {
  return (
    <Pressable style={[styles.card, selected && styles.cardSelected]} onPress={onPress}>
      <View style={[styles.avatar, selected && styles.avatarSelected]}>
        <Text style={styles.avatarText}>{name.slice(0, 1)}</Text>
      </View>
      <Text style={[styles.name, selected && styles.nameSelected]}>{name}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.background,
    borderRadius: 18,
    padding: 10,
    width: '31%',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: colors.border,
  },
  cardSelected: {
    backgroundColor: colors.accentSoft,
    borderColor: colors.button,
  },
  avatar: {
    width: 46,
    height: 46,
    borderRadius: 23,
    backgroundColor: colors.card,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
  },
  avatarSelected: {
    backgroundColor: colors.button,
  },
  avatarText: {
    color: colors.textPrimary,
    fontSize: 16,
    fontWeight: '700',
  },
  name: {
    color: colors.textPrimary,
    fontSize: 12,
    textAlign: 'center',
  },
  nameSelected: {
    color: colors.buttonText,
  },
});
